import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { MediaQuery } from '@grandvisionhq/common';
import { ProductBlockGrid } from '@grandvisionhq/lib-visuals';
import { useIntl } from '@grandvisionhq/state';
import { usePlpDatalayerEvents } from '../../DataLayer/hooks/use-plp-datalayer-events.js';
import '../../lib-components/FeaturedProducts/FeaturedProducts.js';
import '@grandvisionhq/svc-tealium/utils';
import '@grandvisionhq/analytics';
import '@grandvisionhq/fun-search';
import '@grandvisionhq/inventory';
import '@grandvisionhq/utils';
import '@grandvisionhq/commercetools';
import '@grandvisionhq/fun-products';
import '@grandvisionhq/frk-routing';
import '@grandvisionhq/elements';
import { PromotionBlock } from '../../lib-components/PromotionBlock/PromotionBlock.js';
import '@grandvisionhq/carts-v2';
import '@grandvisionhq/content';
import 'classnames';
import '@grandvisionhq/svc-monetate';
import '@grandvisionhq/reviews';
import '@grandvisionhq/lib-utils-react';
import '@grandvisionhq/icons';
import '@grandvisionhq/forms';
import '@grandvisionhq/api-client';
import '@grandvisionhq/shipping';
import '../../ProductDetail/Lenses/components/ConfigureContactLenses/ConfigureContactLensesContainer.js';
import '../../ProductDetail/Lenses/components/ConfigureContactLenses/components/PackageQuantity/PriceAside.js';
import '@grandvisionhq/iris-ui';
import '../../lib-components/RecommendedProducts/types.js';
import '../../lib-components/RecentlyViewedProducts/RecentlyViewedProducts.js';
import { ProductListingBlockWrapper } from './components/ProductListingBlockWrapper/ProductListingBlockWrapper.js';
import { usePromoIndices } from './use-promo-indices.js';

const ProductListingPage = ({ products , pageSize , pageNumber , promotionSmall , promotionBig , reimbursableLogos , isPriceSuffixEnabled ,  })=>{
    const { getLabel  } = useIntl();
    const { pushImpressionsToDatalayer , addImpressionEvent , pushProductClickToDatalayer  } = usePlpDatalayerEvents();
    const { smallPromoIndex , bigPromoIndex  } = usePromoIndices(products.length, !!promotionSmall);
    const isSmallScreen = MediaQuery.useIsPhone();
    const dividerLabel = `${getLabel('common.page')} ${pageNumber}`;
    const showPromos = products.length >= pageSize;
    React.useEffect(()=>{
        pushImpressionsToDatalayer();
    }, []);
    const augmentedProductList = React.useMemo(()=>{
        return products.reduce((result, product, index)=>{
            if (showPromos && !!promotionSmall && result.length === smallPromoIndex) {
                var ref;
                const smallPromoIdentifier = 'promo-small';
                var ref1;
                result.push(/*#__PURE__*/ React.createElement(ProductBlockGrid.Cell, {
                    key: smallPromoIdentifier,
                    isWide: isSmallScreen
                }, /*#__PURE__*/ React.createElement(PromotionBlock, swcHelpers.extends({}, promotionSmall, {
                    id: smallPromoIdentifier,
                    size: isSmallScreen ? 'large' : 'small',
                    ctaLabel: (ref1 = (ref = promotionSmall.links) === null || ref === void 0 ? void 0 : ref.label) !== null && ref1 !== void 0 ? ref1 : ''
                }))));
            }
            if (showPromos && !!promotionBig && result.length === bigPromoIndex) {
                var ref2;
                const bigPromoIdentifier = 'promo-big';
                var ref3;
                result.push(/*#__PURE__*/ React.createElement(ProductBlockGrid.Cell, {
                    key: bigPromoIdentifier,
                    isWide: true
                }, /*#__PURE__*/ React.createElement(PromotionBlock, swcHelpers.extends({}, promotionBig, {
                    id: bigPromoIdentifier,
                    size: "large",
                    ctaLabel: (ref3 = (ref2 = promotionBig.links) === null || ref2 === void 0 ? void 0 : ref2.label) !== null && ref3 !== void 0 ? ref3 : ''
                }))));
                result.push(null);
            }
            if (!product) {
                result.push(/*#__PURE__*/ React.createElement(ProductBlockGrid.Cell, {
                    key: index
                }, ''));
            }
            if (product) {
                const showPriceSuffix = isPriceSuffixEnabled && product.isOfferedWithPrescriptions;
                result.push(/*#__PURE__*/ React.createElement(ProductBlockGrid.Cell, {
                    key: product.masterVariant.sku
                }, /*#__PURE__*/ React.createElement(ProductListingBlockWrapper, {
                    product: product,
                    index: index,
                    reimbursableLogos: reimbursableLogos,
                    addImpressionEvent: addImpressionEvent,
                    pushProductClickToDatalayer: pushProductClickToDatalayer,
                    isPriceSuffixEnabled: showPriceSuffix
                })));
            }
            return result;
        }, []);
    }, [
        products,
        showPromos,
        promotionSmall,
        smallPromoIndex,
        promotionBig,
        bigPromoIndex,
        isSmallScreen,
        isPriceSuffixEnabled,
        reimbursableLogos,
        addImpressionEvent,
        pushProductClickToDatalayer, 
    ]);
    return /*#__PURE__*/ React.createElement(ProductBlockGrid.Container, {
        "data-t": `product-listing-page-${pageNumber}`,
        hasDivider: pageNumber !== 1
    }, pageNumber !== 1 && /*#__PURE__*/ React.createElement(ProductBlockGrid.Divider, null, dividerLabel), /*#__PURE__*/ React.createElement(ProductBlockGrid.Grid, {
        hasSmallPromo: showPromos && !!promotionSmall,
        hasBigPromo: showPromos && !!promotionBig
    }, augmentedProductList));
};

export { ProductListingPage, ProductListingPage as default };
//# sourceMappingURL=ProductListingPage.js.map
